import { StepBase } from './StepBase'
import { PageStepType } from './PageTypes';
import { DataQuery } from '../utils/DataQuery';
import { LogicEngine } from '../LogicEngine/LogicEngine';
import { DataTools } from '../utils/DataTools';

export class StepDashStat extends StepBase
{
	/** Value from the query or other options */
	count: number = 0;

	/** Process the query associated with the stat */
	async processStep(logic: LogicEngine): Promise<boolean>
	{
		await super.processStep(logic);

		/* If this step contains a query= string in the field_id column then process it*/
		let match = this.raw.field_id?.match(/query\s*=\s*([^;]+);(.*)/i);
		if (this.raw.field_id && match)
		{
			let query = match[2];
			let tableToCount = match[1];

			query = logic.processTextReplacement(query);
			tableToCount = logic.processTextReplacement(tableToCount);

			this.count = await DataQuery.instance().executeCountQueryByText(tableToCount + ";" + query);
		} else
		{
			let rawText = logic.processTextReplacement(DataTools.internalValidateString(this.raw.field_id));
			this.count = DataTools.getNumber(rawText) || 0;
		}

		return true;
	}

	/**
	 * The data for Dash Button is <text to show>;<table to count results from>
	 */
	constructor(rawData: PageStepType)
	{
		super(rawData);
	}
}
